export default function ReferralLogic() {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-4">
      <p className="text-3xl font-semibold text-zinc-900 dark:text-zinc-100">
        Referral Logic 🥸🥺🤓
      </p>
    </div>
  );
}
